import reducer from "../common";
export default reducer("GET_AUTOMATED_VISIT_LOGS", []);
